'use strict';

/**
 * Listing of the unfished imports
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoCollectionView = require('base/Colido.CollectionView');
var ImportUnfinishedListItem = require('./import-unfinished-list-item');

var ImportUnfinishedList = ColidoCollectionView.extend({
    childView: ImportUnfinishedListItem,

    className: 'import-progress-list',

    tagName: 'ul',

    sortDefault: 'id.desc',
});

module.exports = ImportUnfinishedList;